import {
  PaginationResultsNotificationDto,
  NotificationCountDto,
  SearchRequest,
} from '@interfaces/models';
import { httpClient } from '@api/interceptors';
import qs from 'qs';

export async function sendNotification(): Promise<void> {
  return httpClient.post('notifications', { json: {} }).json();
}

export async function getNotificationsCount(): Promise<NotificationCountDto> {
  return httpClient.get('notifications/unread-count').json();
}

export async function getPaginatedNotifications(
  request: SearchRequest,
): Promise<PaginationResultsNotificationDto> {
  return httpClient
    .get('notifications', {
      searchParams: qs.stringify(request, { allowDots: true }),
    })
    .json();
}

export async function removeNotification(id: string): Promise<void> {
  return httpClient.delete(`notifications/${id}`).json();
}

export async function markAsRead(id: string): Promise<void> {
  return httpClient.put(`notifications/${id}/mark-as-read`).json();
}

export async function bulkRemoveNotifications(notificationIds: string[]): Promise<void> {
  return httpClient.put(`notifications/bulk-delete`, { json: { notificationIds } }).json();
}

export async function bulkMarkAsRead(notificationIds: string[]): Promise<void> {
  return httpClient.put(`notifications/bulk-mark-as-read`, { json: { notificationIds } }).json();
}
